/**
 * Detect the current device platform from user agent. Used to decide:
 *   - which app-store button to show
 *   - whether to try a deep-link redirect into the installed app
 */
export type Platform = 'ios' | 'android' | 'desktop';

export function detectPlatform(): Platform {
  if (typeof navigator === 'undefined') return 'desktop';
  const ua = navigator.userAgent;
  if (/iPhone|iPad|iPod/i.test(ua)) return 'ios';
  if (/Android/i.test(ua)) return 'android';
  return 'desktop';
}

/**
 * Store URLs. Update these once the app is published.
 */
export const APP_STORE_URLS = {
  ios: 'https://apps.apple.com/app/id6766278438',
  android: 'https://play.google.com/store/apps/details?id=com.djinn.app',
} as const;

/** Public iOS beta invitation. */
export const TESTFLIGHT_URL = 'https://testflight.apple.com/join/dFHDFK5R';

/**
 * Custom URL scheme registered by mobile-frontend (see app.json → expo.scheme).
 * Used as a soft fallback when the user is on mobile but Universal Links / App
 * Links didn't catch the https URL (e.g. app installed but not yet verified).
 */
export const APP_SCHEME = 'djinn';
